export default {
	name: "collection-orders-validation-configurations",
	data() {
		return {
			validationConfigurations: [],
			loading: false
		};
	},
	methods: {
		getCollectionValidationConfigurations(){
			this.loading = true;
			orderService.getOrderChecklistsForCollectionOrders().then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.validationConfigurations = successResponse.data.result;
						permissionsHelper.setControlsBasedOnPermissions();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		saveValidationConfigurations(){
			this.loading = true;
			let request = {
				orderChecklists: this.validationConfigurations
			};
			orderService.markOrderChecklistsAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.getCollectionValidationConfigurations();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Validation Configurations - Collection Orders");
			var breadcrumbs = [];
			var breadcrumbSystem = {
				url: null,
				displayText: "System"
			};
			var reasonsForDeliveryFailureManagementBreadcrumb = {
				url: this.$route.path,
				displayText: "Validation Configurations - Collection Orders"
			};
			breadcrumbs.push(breadcrumbSystem);
			breadcrumbs.push(reasonsForDeliveryFailureManagementBreadcrumb);
			breadcrumbsStoreState.setBreadcrumbs(breadcrumbs);
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getCollectionValidationConfigurations();
	}
};